<template>
    <element-loader
        class="section-loader"
        color="#4F71C3"
        :loading="loading"
    />
</template>

<script>
import './SectionLoader.scss';

export default {
    name: 'SectionLoader',
    props: {
        loading: {
            type: Boolean,
        },
    },
}
</script>
